module.exports = __webpack_public_path__ + "static/28-11669880af80d7d7df805a154b678f9d.png";